import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

// New companies per month for the last 12 months.
// The server sends 12 entries, oldest first: [{ month: "Oct 2025", count: 3 }, ...]
const BarChart = ({ companiesGraphData }) => {
    const rows = Array.isArray(companiesGraphData) ? companiesGraphData : [];

    const data = {
        labels: rows.map((val) => val.month),
        datasets: [
            {
                label: 'New companies',
                data: rows.map((val) => val.count),
                backgroundColor: 'rgba(29, 78, 216, 0.75)',
                hoverBackgroundColor: 'rgba(29, 78, 216, 0.95)',
                borderRadius: 6,
                maxBarThickness: 42,
            },
        ],
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: { display: false },
            title: { display: false },
            tooltip: {
                callbacks: {
                    label: (ctx) => `${ctx.parsed.y} new ${ctx.parsed.y === 1 ? 'company' : 'companies'}`,
                },
            },
        },
        scales: {
            x: {
                grid: { display: false },
                ticks: { color: '#64748b', font: { family: 'Inter, "Segoe UI", sans-serif', size: 12 } },
            },
            y: {
                beginAtZero: true,
                grid: { color: '#eef1f6' },
                ticks: {
                    precision: 0, // whole numbers only
                    color: '#64748b',
                    font: { family: 'Inter, "Segoe UI", sans-serif', size: 12 },
                },
            },
        },
    };

    return (
        <div style={{ background: 'white', width: '100%' }}>
            <div style={{ fontSize: 13, color: '#64748b', marginBottom: 12 }}>
                New companies per month, last 12 months
            </div>
            <div className="chart-container" style={{ position: 'relative', height: '340px', width: '100%' }}>
                <Bar data={data} options={options} />
            </div>
        </div>
    );
};

export default BarChart;
